var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60.011,
    viewBox: "0 0 60 60.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "EMI",
    d: "M28.755,15A3.751,3.751,0,1,1,25,18.753,3.752,3.752,0,0,1,28.755,15Zm-15-7.5A3.751,3.751,0,1,0,10,3.751,3.752,3.752,0,0,0,13.752,7.5ZM58.1,32.543l-17.016,19.1a25.026,25.026,0,0,1-18.668,8.372H10a10.012,10.012,0,0,1-10-10v-12.5a10.012,10.012,0,0,1,10-10H32.151a7.859,7.859,0,0,1,6.724,3.8l8.041-8.837a7.527,7.527,0,0,1,10.637-.5A7.553,7.553,0,0,1,58.1,32.541Zm-3.916-6.879a2.593,2.593,0,0,0-1.82-.655,2.51,2.51,0,0,0-1.75.823L39.547,37.994a7.9,7.9,0,0,1-6.286,5.148l-12.9,1.843a2.5,2.5,0,1,1-.708-4.948l12.9-1.843a2.856,2.856,0,0,0-.4-5.684H10a5.006,5.006,0,0,0-5,5v12.5a5.006,5.006,0,0,0,5,5H22.417a20.022,20.022,0,0,0,14.935-6.7l17.016-19.1a2.541,2.541,0,0,0-.183-3.553ZM14.278,22.109a2.5,2.5,0,0,0,3.456-.75L28.983,3.853a2.5,2.5,0,1,0-4.208-2.7l-11.252,17.5a2.5,2.5,0,0,0,.753,3.456Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmi);
export default __webpack_public_path__ + "static/media/EMI.38a18c2a9322dc79f2f846b1dbf7288f.svg";
export { ForwardRef as ReactComponent };